import React from 'react';
import StyledContent from './styled';

export default function GarageMembershipTag() {
  return (
    <StyledContent>
      <h3>This is a Garage Membership Booking</h3>
    </StyledContent>
  );
}
